@import '../../theme/global';

snap-alert-description {
  display: block;
  font-family: $font-family;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: 0.5rem;
}
